import { render } from "./CommentList.vue?vue&type=template&id=65140dd8&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"

import "./CommentList.vue?vue&type=style&index=0&id=65140dd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65140dd8"]])

export default __exports__